var map = {
	"./arc": 766,
	"./arc.js": 766,
	"./back": 676,
	"./back.js": 676,
	"./beginPath": 14,
	"./beginPath.js": 14,
	"./clear": 86,
	"./clear.js": 86,
	"./closePath": 745,
	"./closePath.js": 745,
	"./eval": 203,
	"./eval.js": 203,
	"./example": 51,
	"./example.js": 51,
	"./fill": 281,
	"./fill.js": 281,
	"./fillCanvas": 578,
	"./fillCanvas.js": 578,
	"./fillText": 577,
	"./fillText.js": 577,
	"./forward": 957,
	"./forward.js": 957,
	"./left": 865,
	"./left.js": 865,
	"./move": 772,
	"./move.js": 772,
	"./penDown": 223,
	"./penDown.js": 223,
	"./penUp": 18,
	"./penUp.js": 18,
	"./resetPosition": 827,
	"./resetPosition.js": 827,
	"./right": 365,
	"./right.js": 365,
	"./setFillStyle": 330,
	"./setFillStyle.js": 330,
	"./setFont": 542,
	"./setFont.js": 542,
	"./setIcon": 73,
	"./setIcon.js": 73,
	"./setImage": 714,
	"./setImage.js": 714,
	"./setInitialPosition": 916,
	"./setInitialPosition.js": 916,
	"./setInitialRotation": 246,
	"./setInitialRotation.js": 246,
	"./setLineCap": 782,
	"./setLineCap.js": 782,
	"./setLineJoin": 726,
	"./setLineJoin.js": 726,
	"./setLineWidth": 859,
	"./setLineWidth.js": 859,
	"./setPosition": 134,
	"./setPosition.js": 134,
	"./setSize": 876,
	"./setSize.js": 876,
	"./setSpeed": 804,
	"./setSpeed.js": 804,
	"./setStrokeActive": 182,
	"./setStrokeActive.js": 182,
	"./setStrokeColorHSL": 777,
	"./setStrokeColorHSL.js": 777,
	"./setStrokeColorRGB": 138,
	"./setStrokeColorRGB.js": 138,
	"./setStrokeStyle": 531,
	"./setStrokeStyle.js": 531,
	"./setTextAlign": 989,
	"./setTextAlign.js": 989,
	"./setTextBaseline": 66,
	"./setTextBaseline.js": 66,
	"./sleep": 797,
	"./sleep.js": 797,
	"./stroke": 93,
	"./stroke.js": 93,
	"./strokeText": 780,
	"./strokeText.js": 780,
	"./turn": 919,
	"./turn.js": 919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 324;